import {
    getWallPropAreaConfig,
    getWallPropSpace,
    WallPropConfig,
} from "@/state/RoomConfig/WallConfig";
import { SpaceWithConfig } from "../area/LayoutFunctions";
import { Vector2Like } from "three";
import { AreaConfig } from "../area/AreaConfig";
import { Space } from "../area/AreaLayout";
import { RoomConfig, WallKey } from "@/state/RoomConfig/RoomConfig";

export type WallPropAreaData = {
    root: Space;
    otherChildren: SpaceWithConfig[];
    coordinateProvider: (cursor: Vector2Like) => number;
    propAreaConfig: AreaConfig;
    prop: WallPropConfig;
};

export const getWallPropAreaData = (
    roomConfig: RoomConfig,
    propKey: string,
    wallKey: WallKey
): WallPropAreaData | undefined => {
    const wall = roomConfig[wallKey];
    const prop = wall.props.find((prop) => prop.key === propKey);
    if (!prop) return undefined;

    const isSideWall =
        wall.key === roomConfig.leftWall.key || wall.key === roomConfig.rightWall.key;
    const wallSize = isSideWall ? roomConfig.depth : roomConfig.width;

    const root: Space = {
        type: "1axis",
        start: 0,
        end: wallSize,
        size: wallSize,
    };

    const otherChildren: SpaceWithConfig[] = wall.props
        .filter((prop) => prop.key !== propKey)
        .map((prop) => ({
            space: getWallPropSpace(prop),
            config: getWallPropAreaConfig(prop.width),
        }));

    let coordinateProvider: (cursor: Vector2Like) => number = () => 0;
    if (wall.key === roomConfig.backWall.key) {
        coordinateProvider = (cursor) => wallSize / 2 + cursor.x;
    } else if (wall.key === roomConfig.frontWall.key) {
        coordinateProvider = (cursor) => wallSize / 2 - cursor.x;
    } else if (wall.key === roomConfig.leftWall.key) {
        coordinateProvider = (cursor) => wallSize / 2 - cursor.y;
    } else if (wall.key === roomConfig.rightWall.key) {
        coordinateProvider = (cursor) => wallSize / 2 + cursor.y;
    }

    return {
        root,
        otherChildren,
        coordinateProvider,
        propAreaConfig: getWallPropAreaConfig(prop.width),
        prop,
    };
};
